import { render, staticRenderFns } from "./AddIntegration.vue?vue&type=template&id=70624835&scoped=true&lang=pug&"
import script from "./AddIntegration.vue?vue&type=script&lang=js&"
export * from "./AddIntegration.vue?vue&type=script&lang=js&"
import style0 from "./AddIntegration.vue?vue&type=style&index=0&id=70624835&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70624835",
  null
  
)

export default component.exports